import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Code2,
  Zap,
  ShieldCheck,
  Globe,
  Lock,
} from "lucide-react";

const features = [
  {
    title: "智能系统代理管理",
    icon: <Globe className="w-6 h-6 text-blue-500" />,
    items: [
      "一键托管：支持一键开启/关闭系统全局代理（HTTP/HTTPS/SOCKS）。",
      "配置保护：自动备份原有的系统代理设置，并在应用退出时智能恢复，防止配置丢失。",
      "灵活绕过：支持自定义绕过代理的域名列表（Bypass List）。",
    ],
  },
  {
    title: "MITM 流量拦截与调试",
    icon: <ShieldCheck className="w-6 h-6 text-green-500" />,
    items: [
      "全协议支持：支持 HTTP、HTTPS 以及 WebSocket 协议的流量拦截。",
      "实时监控：提供实时的请求日志信息。",
      "解密查看：内置中间人攻击（MITM）机制，可解密 HTTPS 流量。",
    ],
  },
  {
    title: "强大的规则引擎",
    icon: <Code2 className="w-6 h-6 text-purple-500" />,
    items: [
      "URL 重写：支持正则匹配重写；支持路径前缀或精确路径匹配转发。",
      "内容替换：实时替换响应体（Response Body）文本，用于调试接口数据或注入脚本。",
      "请求拦截：直接阻断特定请求（返回 403），模拟接口异常。",
    ],
  },
  {
    title: "自动化证书管理",
    icon: <Lock className="w-6 h-6 text-orange-500" />,
    items: [
      "一键信任：内置 CA 证书生成器，支持一键安装并信任根证书到系统钥匙串（macOS）。",
      "生命周期管理：支持查看证书有效期，自动处理证书续期与更新，确保持续可用的 HTTPS 解密能力。",
    ],
  },
  {
    title: "技术架构",
    icon: <Zap className="w-6 h-6 text-yellow-500" />,
    items: [
      "高性能核心：后端基于 Rust 开发，通过 mitm 模块处理高并发网络流量，低资源占用。",
      "现代化 UI：前端采用 React + Tailwind CSS，配合 Shadcn UI 组件库，提供简洁流畅的操作体验。",
      "跨平台基础：基于 Tauri 框架构建，拥有原生级的性能体验。",
    ],
  },
];

export function LandingFeatures() {
  return (
    <main className="w-full max-w-6xl mx-auto px-6 pb-24">
      <h2 className="text-3xl font-bold text-center mb-12">功能概览</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((feature, idx) => (
          <Card
            key={idx}
            className="border border-neutral-200 dark:border-neutral-800 shadow-sm hover:shadow-md transition-shadow bg-white/50 dark:bg-neutral-900/50 backdrop-blur-sm"
          >
            <CardHeader className="pb-3">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-neutral-100 dark:bg-neutral-800 rounded-lg">
                  {feature.icon}
                </div>
                <CardTitle className="text-lg">{feature.title}</CardTitle>
              </div>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2">
                {feature.items.map((item, i) => (
                  <li
                    key={i}
                    className="text-sm text-neutral-600 dark:text-neutral-400 flex items-start"
                  >
                    <span className="mr-2 text-neutral-400 mt-1">•</span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </main>
  );
}
